import { render, staticRenderFns } from "./RestrictedZones.vue?vue&type=template&id=0d253efa&scoped=true&"
import script from "./RestrictedZones.vue?vue&type=script&lang=js&"
export * from "./RestrictedZones.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d253efa",
  null
  
)

export default component.exports